// Packages
import { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import rightangle from "../../assets/images/rightangle.svg";
import { Button, Modal } from "react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import userService from "../../services/user.service";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import leftarrow from "../../assets/images/leftarrow.svg";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import successimg from "../../assets/images/successimg.png";
import { BsXLg } from "react-icons/bs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// Styles
import "./superAdmin.css";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../Validation/ValidationSchemas";
import SuccessDialog from "../schoolAdminPortal/Popups/SuccessDialog";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

// Material Ui

class WebsiteDetails extends Component {
  constructor() {
    super();
    this.state = {
      showfive: false,
      disabled: false,
      redirectToRow: false,
      blog: "",
      contactUs: "",
      guidelines: "",
      highlights: "",
      home: "",
      pricing: "",
      successPopUp: false,
      msg: "",
      loginRole: getFromLocalStorage("loginRole"),
    };
  }
  handleModelfive() {
    this.setState({ showfive: !this.state.showfive });
  }
  componentDidMount() {
    const acticve = document.getElementById("Website");
    if (acticve) {
      acticve.classList.add("active");
    }
    this.getHeaderData();
    this.getFooterData();
  }

  getHeaderData() {
    userService.getHeaderData().then((res) => {
      var blog = res.data.data.headerMenuDetailsRespones[0].blog;
      var contactUs = res.data.data.headerMenuDetailsRespones[0].contactUs;
      var guidelines = res.data.data.headerMenuDetailsRespones[0].guidelines;
      var highlights = res.data.data.headerMenuDetailsRespones[0].highlights;
      var home = res.data.data.headerMenuDetailsRespones[0].home;
      var pricing = res.data.data.headerMenuDetailsRespones[0].pricing;
      var headId = res.data.data.headerMenuDetailsRespones[0].id;
      this.setState({
        blog,
        contactUs,
        guidelines,
        highlights,
        home,
        pricing,
        headId,
      });
    });
  }

  getFooterData() {
    userService.getFooterData().then((res) => {
      var details = res.data.data.footerDetailsResponses[0].details;
      var facebookLink = res.data.data.footerDetailsResponses[0].facebookLink;
      var instagramLink = res.data.data.footerDetailsResponses[0].instagramLink;
      var linkedinLink = res.data.data.footerDetailsResponses[0].linkedinLink;
      var twitterLink = res.data.data.footerDetailsResponses[0].twitterLink;
      var youtubeLink = res.data.data.footerDetailsResponses[0].youtubeLink;
      var footId = res.data.data.footerDetailsResponses[0].id;
      this.setState({
        details,
        facebookLink,
        instagramLink,
        linkedinLink,
        twitterLink,
        youtubeLink,
        footId,
      });
    });
  }

  headerPostUpdatedCall() {
    const { blog, contactUs, guidelines, highlights, home, pricing } =
      this.state;
    userService
      .addHeaderMenus(blog, contactUs, guidelines, highlights, home, pricing)
      .then((res) => {
        var showMessage = res.data.data;
        this.setState({ showMessage });
        this.openDialogSuccess();
      });
  }

  footerPostUpdatedCall() {
    const {
      details,
      facebookLink,
      instagramLink,
      linkedinLink,
      twitterLink,
      youtubeLink,
    } = this.state;
    userService
      .addFooterMenus(
        details,
        facebookLink,
        instagramLink,
        linkedinLink,
        twitterLink,
        youtubeLink
      )
      .then((res) => {
        var showMessage = res.data.data;
        this.setState({ showMessage });
        this.openDialogSuccess();
      });
  }

  UpdateheaderPostUpdatedCall({
    menuLink1,
    menuLink2,
    menuLink3,
    menuLink4,
    menuLink5,
    menuLink6,
  }) {
    const { headId } = this.state;
    userService
      .updateHeaderMenus(
        menuLink5,
        menuLink6,
        menuLink2,
        menuLink3,
        menuLink1,
        menuLink4,
        headId
      )
      .then((res) => {
        let showMessage = res.data.data;
        this.setState({
          showMessage,
          msg: "Header Menu Updated Successfully.",
          successPopUp: true,
          disabled: false,
        });
      });
  }

  UpdateFooterPostUpdatedCall({
    footerDetails,
    facebookLink,
    twitterLink,
    linkedInLink,
    youtubeLink,
    instagramLink,
  }) {
    this.setState({ disabled: true });
    const { footId } = this.state;
    userService
      .updateFooterMenus(
        footerDetails,
        facebookLink,
        instagramLink,
        linkedInLink,
        twitterLink,
        youtubeLink,
        footId
      )
      .then((res) => {
        let showMessage = res.data.data;
        this.setState({
          showMessage,
          msg: "Footer Data Updated Successfully",
          successPopUp: true,
        });
      });
  }

  openDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }
  closeDialogSuccess() {
    this.setState({ openSuccess: !this.state.openSuccess });
  }

  toggleSuccessDialog = () => {
    const { successPopUp } = this.state;
    this.setState({ successPopUp: !successPopUp });
  };

  render() {
    const {
      blog,
      contactUs,
      guidelines,
      highlights,
      home,
      pricing,
      showMessage,
      details,
      facebookLink,
      instagramLink,
      linkedinLink,
      twitterLink,
      youtubeLink,
      disabled,
      redirectToRow,
      successPopUp,
      msg,
      openSuccess,
      showfive,
      loginRole,
    } = this.state;

    if (redirectToRow) {
      return <Redirect to="/website" />;
    }

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div className="">
            <SuperAdminDashboard />
            <div className="content-layout">
              <Tabs>
                <div className="row w-100">
                  <div className="col-12 col-md-4 col-lg-3 fixed-left-container">
                    <TabList className="">
                      <div className="pd-5">
                        <button
                          className="custom-back-button mg-bottom-10 mg-top-10"
                          onClick={() => this.setState({ redirectToRow: true })}
                        >
                          <span className="custom-back-button-icon">
                            <ArrowBackIcon className="backarrow-icon" />
                          </span>
                          <div className="custom-back-button-text d-flex-center w-100">
                            <span className="bold fs-18">
                              Manage Website Details
                            </span>
                          </div>
                        </button>
                      </div>

                      <Tab>
                        <div className="d-flex justify-content-between w-100">
                          <p>Header Menu</p>
                          <span className="">
                            <img alt="" src={rightangle}></img>
                          </span>
                        </div>
                      </Tab>
                      <Tab>
                        <div className="d-flex justify-content-between w-100">
                          <p>Footer</p>
                          <span className="">
                            <img alt="" src={rightangle}></img>
                          </span>
                        </div>
                      </Tab>
                    </TabList>
                  </div>
                  {/* Header Menu */}
                  <div className="col-12 col-md-8 col-lg-9 w-100 web-panel ">
                    <TabPanel>
                      <Formik
                        initialValues={{
                          menuLink1: home,
                          menuLink2: guidelines,
                          menuLink3: highlights,
                          menuLink4: pricing,
                          menuLink5: blog,
                          menuLink6: contactUs,
                        }}
                        enableReinitialize
                        validationSchema={validationSchema.headerMenuDetails}
                        onSubmit={(values) =>
                          this.UpdateheaderPostUpdatedCall(values)
                        }
                      >
                        {(formik) => (
                          <Form>
                            <div className="height-90-vh">
                              <div className="panel-content conclass-website">
                                <div className="row">
                                  <div className="col-lg-8 col-md-12">
                                    <label className="email black fs-18 emailtxtweb">
                                      HEADER MENU
                                    </label>
                                    <br />
                                    <Field
                                      type="text"
                                      name="menuLink1"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.menuLink1 && "is-invalid"
                                      }`}
                                      placeholder="Home"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.menuLink1}
                                    </div>
                                  </div>
                                </div>
                                <div className="clear20"></div>

                                <div className="row">
                                  <div className="col-lg-8 col-md-12">
                                    <Field
                                      type="text"
                                      name="menuLink2"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.menuLink2 && "is-invalid"
                                      }`}
                                      placeholder="Guidelines"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.menuLink2}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4"></div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-12">
                                    <Field
                                      type="text"
                                      name="menuLink3"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.menuLink3 && "is-invalid"
                                      }`}
                                      placeholder="Highlights"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.menuLink3}
                                    </div>
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-12">
                                    <Field
                                      type="text"
                                      name="menuLink4"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.menuLink4 && "is-invalid"
                                      }`}
                                      placeholder="Pricing"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.menuLink4}
                                    </div>
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-12">
                                    <Field
                                      type="text"
                                      name="menuLink5"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.menuLink5 && "is-invalid"
                                      }`}
                                      placeholder="Blog"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.menuLink5}
                                    </div>
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-12">
                                    <Field
                                      type="text"
                                      name="menuLink6"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.menuLink6 && "is-invalid"
                                      }`}
                                      placeholder="Contact Us"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.menuLink6}
                                    </div>
                                  </div>
                                </div>
                                <button
                                  type="submit"
                                  className={`mg-top-20 ${
                                    formik.isValid
                                      ? "saveBtn1"
                                      : "saveBtn1 activv"
                                  }`}
                                  disabled={!formik.isValid}
                                >
                                  Save
                                </button>
                                <div className="clear20"></div>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </TabPanel>
                    {/* Footer section */}
                    <TabPanel>
                      <Formik
                        initialValues={{
                          footerDetails: details,
                          facebookLink: facebookLink,
                          twitterLink: twitterLink,
                          linkedInLink: linkedinLink,
                          youtubeLink: youtubeLink,
                          instagramLink: instagramLink,
                        }}
                        enableReinitialize
                        validationSchema={validationSchema.footerDetailsSchema}
                        onSubmit={(values) =>
                          this.UpdateFooterPostUpdatedCall(values)
                        }
                      >
                        {(formik) => (
                          <Form>
                            <div>
                              <div className="panel-content conclass-website">
                                <div className="row">
                                  <div className="col-lg-8">
                                    <div class="form-group display-grid">
                                      <label
                                        for="comment"
                                        className="black fs-18 detailstxt"
                                      >
                                        DETAILS
                                      </label>
                                      <Field
                                        as="textarea"
                                        rows="3"
                                        col="12"
                                        id="comment"
                                        className={`form-control teaxtareatxt fs-18 ${
                                          formik.errors.footerDetails &&
                                          "is-invalid"
                                        }`}
                                        name="footerDetails"
                                        placeholder="Dummy Mockup and dummy content is used here Use video and data analysis to detect vulnerabilities. Decide what to focus on and develop technical and tactical strategies to im"
                                      />
                                      <div className="errorMsg fs-14 medium">
                                        {formik.errors.footerDetails}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <hr></hr>

                                <div className="clear10"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-8">
                                    <label className="email black fs-18 emailtxtweb">
                                      FACEBOOK LINK
                                    </label>
                                    <br />
                                    <Field
                                      type="text"
                                      name="facebookLink"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.facebookLink &&
                                        "is-invalid"
                                      }`}
                                      placeholder="Link"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.facebookLink}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <br />
                                    <br />
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-8">
                                    <label className="email black fs-18 emailtxtweb">
                                      TWITTER LINK
                                    </label>
                                    <br />
                                    <Field
                                      type="text"
                                      name="twitterLink"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.twitterLink &&
                                        "is-invalid"
                                      }`}
                                      placeholder="Link"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.twitterLink}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <br />
                                    <br />
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-8">
                                    <label className="email black fs-18 emailtxtweb">
                                      LINKEDIN LINK
                                    </label>
                                    <br />
                                    <Field
                                      type="text"
                                      name="linkedInLink"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.linkedInLink &&
                                        "is-invalid"
                                      }`}
                                      placeholder="Link"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.linkedInLink}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <br />
                                    <br />
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-8">
                                    <label className="email black fs-18 emailtxtweb">
                                      YOUTUBE LINK
                                    </label>
                                    <br />
                                    <Field
                                      type="text"
                                      name="youtubeLink"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.youtubeLink &&
                                        "is-invalid"
                                      }`}
                                      placeholder="Link"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.youtubeLink}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <br />
                                    <br />
                                  </div>
                                </div>
                                <div className="clear20"></div>
                                <div className="row">
                                  <div className="col-lg-8 col-md-8">
                                    <label className="email black fs-18 emailtxtweb">
                                      INSTAGRAM LINK
                                    </label>
                                    <br />
                                    <Field
                                      type="text"
                                      name="instagramLink"
                                      className={`form-control w-100 emailtxtbox ${
                                        formik.errors.instagramLink &&
                                        "is-invalid"
                                      }`}
                                      placeholder="Link"
                                    />
                                    <div className="errorMsg fs-14 medium">
                                      {formik.errors.instagramLink}
                                    </div>
                                  </div>
                                  <div className="col-lg-4 col-md-4">
                                    <br />
                                    <br />
                                  </div>
                                </div>
                                <button
                                  type="submit"
                                  className={`mg-top-20 ${
                                    formik.isValid
                                      ? "saveBtn1"
                                      : "saveBtn1 activv"
                                  }`}
                                  disabled={!formik.isValid}
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </TabPanel>
                  </div>
                </div>
              </Tabs>
            </div>

            <Modal
              id="mwidth"
              show={showfive}
              onHide={() => {
                this.handleModelfive();
              }}
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-md-6 col-lg-6 text-center mx-auto">
                    <h6 className="fs-20 semi-bold black text-center">
                      Are You Sure?
                    </h6>
                    <p className="fs-16 semi-bold black">
                      Clicking on “Save” will Hide the selected Header Menu from
                      the system!
                    </p>
                    <div className="clear10"></div>
                  </div>
                  <div className="col-12 col-lg-12 text-center">
                    <button type="button" className="cancelbtn mr-2">
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="canredbtn"
                      onClick={() => {
                        this.handleModelfive();
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
            <Dialog
              id="dialogBoxCancel"
              className="dialog-style updateschool"
              open={openSuccess}
              onClose={this.closeDialogSuccess.bind(this)}
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-1 text-right ml-auto">
                    <BsXLg
                      onClick={this.closeDialogSuccess.bind(this)}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-12 text-center">
                    <img
                      src={successimg}
                      alt="success"
                      className="successimg-new"
                    ></img>
                    <div className="clear20"></div>
                    <p className="fs-20 semi-bold text-center">{showMessage}</p>
                    <div className="clear30"></div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                    <button
                      type="button"
                      class="donebtn"
                      onClick={this.closeDialogSuccess.bind(this)}
                    >
                      Ok
                    </button>
                  </div>
                </div>

                <div className="clear10"></div>

                <div className="clear10"></div>
              </DialogContent>
            </Dialog>

            <SuccessDialog
              successPopUp={successPopUp}
              toggleSuccessDialog={this.toggleSuccessDialog}
              msg={msg}
            />
            {/* end */}
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default WebsiteDetails;
